import React, { useEffect, useState } from 'react'
import { archiveBlogCategory, getBlogCategory } from '../../../actions/utilitiesAction'
import Categorylist from '../../../component/Utilities/Blog/CategoryList'
import constant from '../../../constant'
export default function CategoryList() {

    const [list, setList] = useState(undefined)
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {
        getBlogCategorys(currentPage)
        document.title = constant.title.BlogCategoryList
    }, [currentPage])

    const getBlogCategorys = (page) => {
        getBlogCategory({ page: page }).then((res) => {
            setList(res.result.list)
            setCount(res.result.count)
        }).catch((err) => {
            alert(err)
        })
    }
    const updateStatus = (model) => {
        archiveBlogCategory(model).then((res) => {
            if (res.status) {
                getBlogCategorys(currentPage)
            } else {
                alert(res.error)
            }
        }).catch((err) => {
            alert(err)
        })
    }
    return (
        <React.Fragment>
            <Categorylist list={list}
                updateStatus={updateStatus}
                getBlogCategorys={(page => getBlogCategorys(page))}
                count={count}
                setPage={setCurrentPage} />
        </React.Fragment>
    )
}
